export function localTimeZoneToUtc(): string {
  try {
    const dateObj = new Date();
    return dateObj?.toISOString()?.slice(0, -1);
  } catch {
    return "";
  }
}
